import { User } from '__generated__/graphql'
import { SPECIAL_REFERRAL_CODE_TO_TRACK } from 'shared/constants'
import { GTM_EVENTS } from 'shared/constants/gtm-events'
import { notificationStateVar } from 'shared/store/notification'
import { notifyWithArbitraryErrorMessage } from 'shared/utils/notify-on-error'
import { pushGtmEvent } from 'shared/utils/push-gtm-event'
import {
  isConnectWalletDialogOpenVar,
  isSignInDialogOpenVar,
  isSignUpDialogOpenVar
} from '../store/dialogs'
import {
  isUserDetectedRegisteredVar,
  walletAddressVar,
  walletSignatureVar,
  wizardFlowTypeVar,
  wizardStepVar
} from '../store/wizard.store'
import { WizardFlowType, WizardMode, WizardStep } from '../types'
import { getWalletErrorMessage } from './connect-solana-adapter'
import { getWizardNextStep } from './get-wizard-next-step'

export function notifyOnWalletInfo(message: string) {
  notificationStateVar({
    isOpen: true,
    type: 'info',
    title: 'Info',
    description: message
  })
}

export function notifyOnWalletError(message: string) {
  notificationStateVar({
    isOpen: true,
    type: 'error',
    title: 'Error!',
    description: message
  })
}

export function storeWalletSignature(signature: string, walletAddress: string) {
  walletSignatureVar(signature)
  walletAddressVar(walletAddress)
}

export function notifySignFailure(error: unknown, disconnect: () => void) {
  if (error instanceof Error && error.message.startsWith('Cannot')) {
    notifyWithArbitraryErrorMessage(error.message)
    return
  }

  notifyOnWalletError(getWalletErrorMessage(error))
  disconnect()
}

export function openWizardAfterSign(
  wizardMode: WizardMode | null,
  wizardFlowType: WizardFlowType,
  wizardStep: WizardStep
) {
  const nextStep = getWizardNextStep(wizardMode, wizardFlowType, wizardStep)
  wizardStepVar(nextStep ?? WizardStep.init)

  if (wizardMode === WizardMode.signUp) {
    isSignUpDialogOpenVar(true)
    return
  }

  isSignInDialogOpenVar(true)
}

function trackRegistration(walletAddress: string, referralCode: string) {
  if (referralCode === SPECIAL_REFERRAL_CODE_TO_TRACK) {
    pushGtmEvent(GTM_EVENTS.uniqueReferrerRegister, {
      code: referralCode,
      conversion_id: walletAddress
    })
    return
  }

  pushGtmEvent(GTM_EVENTS.registrationComplete, {
    conversion_id: walletAddress
  })
}

export function applyUserLookupResult(
  userData: User | undefined,
  walletAddress: string,
  referralCode: string
) {
  if (userData?.id) {
    isUserDetectedRegisteredVar(true)
    wizardStepVar(WizardStep.done)
    return
  }

  wizardFlowTypeVar(WizardFlowType.web3)
  wizardStepVar(WizardStep.name)
  trackRegistration(walletAddress, referralCode)
}

export function keepConnectWalletDialogOpen() {
  isConnectWalletDialogOpenVar(true)
}
